import React from 'react';
import { Link } from 'react-router-dom'

export default function Outcomeofboardmeeting(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Outcome of Board Meeting</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Board Meetings</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Outcome of Board Meeting</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			  <div className="table-responsive table_heading">
			  <table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Outcome Reports 2026-27</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				    <tr>
					  <td>Outcome of BM 29.08.2026</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/Outcome-of-BM-29.08.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Outcome of BM 10.08.2026</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/Outcome-of-BM-10.08.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>Outcome of BM 30.05.2026</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/Outcome-of-BM-30.05.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				  </tbody> 
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Outcome Reports 2025-26</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				    <tr>
					  <td>Outcome of BM_12.02.2026</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/outcome-of-BM-12.02.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				    <tr>
					  <td>Outcome of BM_14.11.2025</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/outcome-of-BM-14.11.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 

					<tr>
					  <td>Outcome of BM_12.08.2025</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/outcome-of-BM-12.08.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>Outcome of BM_14.05.2025</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/c518aa32-d316-4ce5-90e6-f10cde639f53.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Outcome Reports 2024-25</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>Outcome of BM_11.02.2025</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/Outcome_of_BM_11.02.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  <tr>
					  <td>outcomes of BM_08.08.2024</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/outcome_of_BM_08.08.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>outcome of BM_30.05.2024</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/outcome_of_BM_30.05.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Outcome of BM_01.04.2024</td>
					  <td width={280} className="text-center">
						<Link to="/outcome/Outcome_of_BM_01.04.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				  </tbody>
				</table>
			  </div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}